<div id="i3-mtc-container">
    <div id="i3-mtc-wrapper" class="prevent-select">
        <div id="i3-mtc-detail">
            <div id="i3-mtc-title">
                <fa-icon icon="circle" [ngStyle]="{'color': icoColor}"></fa-icon>
                {{ taskType | translate }}
            </div>
            <div id="i3-mtc-value">{{ task.description | translate }}</div>
        </div>
        <div id="i3-mtc-parts">
            {{ task.partsToOrder }}
        </div>
        <div id="i3-mtc-due">
            {{ task.nextDueInDate | date:'MM/dd/yy' }}
        </div>
    </div>
</div>
